import { SportsStatIdConfig } from '@collector/desktop-feature-statistics'
import {
  RugbyLeagueStatId,
  RugbyLeagueSubParticipantStatId,
} from '@collector/sportsapi-client-legacy'

export const teamStatIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: RugbyLeagueStatId.Tries },
  { sportStatId: RugbyLeagueStatId.Conversions },
  { sportStatId: RugbyLeagueStatId.DropGoals },
  { sportStatId: RugbyLeagueStatId.TacklesMade },
  { sportStatId: RugbyLeagueStatId.TackleBreaks },
  { sportStatId: RugbyLeagueStatId.Offloads },
  { sportStatId: RugbyLeagueStatId.LineOuts, name: 'Lineouts' },
  { sportStatId: RugbyLeagueStatId.Scrums },
  { sportStatId: RugbyLeagueStatId.TurnoversWon },
]

export const teamStatsAccordionIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: RugbyLeagueStatId.YellowCards },
  { sportStatId: RugbyLeagueStatId.RedCards },
  { sportStatId: RugbyLeagueStatId.GreenCards },
  { sportStatId: RugbyLeagueStatId.Substitution },
  {
    sportStatId: RugbyLeagueStatId.EffectiveTacklePercentage,
    format: { percent: true },
  },
  {
    sportStatId: RugbyLeagueStatId.ScrumsEfficiency,
    format: { percent: true },
  },
  { sportStatId: RugbyLeagueStatId.DropGoalsMissed },
  {
    sportStatId: RugbyLeagueStatId.DropGoalsPercentage,
    format: { percent: true },
  },
]

export const playerStatIdConfigs: SportsStatIdConfig[] = [
  { sportStatId: RugbyLeagueSubParticipantStatId.PointsScored },
  { sportStatId: RugbyLeagueSubParticipantStatId.Tries },
  {
    sportStatId: RugbyLeagueSubParticipantStatId.Conversions,
    name: 'Conversion Goals',
  },
  { sportStatId: RugbyLeagueSubParticipantStatId.ConversionsMissed },
  { sportStatId: RugbyLeagueSubParticipantStatId.PenaltyKickGoals },
  { sportStatId: RugbyLeagueSubParticipantStatId.PenaltyKicksMissed },
  { sportStatId: RugbyLeagueSubParticipantStatId.DropGoals },
  { sportStatId: RugbyLeagueSubParticipantStatId.DropGoalsMissed },
  { sportStatId: RugbyLeagueSubParticipantStatId.YellowCards },
  { sportStatId: RugbyLeagueSubParticipantStatId.RedCards },
  { sportStatId: RugbyLeagueSubParticipantStatId.GreenCards },
  { sportStatId: RugbyLeagueSubParticipantStatId.Appearance },
  { sportStatId: RugbyLeagueSubParticipantStatId.FirstLineups },
]
